import React from 'react';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';

import Pager from 'react-pager';
import {
  individualTopInfoBarData,
  corperateTopInfoBarData,
  individualCustomerProfile,
  corperateCustomerProfile,
  slateValueJson
} from './metadata';

import PastHitModal from './PastHitModal';
import TopInfoBar from './TopInfoBar';
import CustomerProfilePanel from './CustomerProfilePanel';
import Explainability from './Explainability';
import { Value } from 'slate';

import {
  getInvestDetailData,
  updateHitInfo,
  resetInvestDetailData,
  getInvestDetailHitData,
  getInvestDetailPastHitsData,
  resetInvestDetailPastHitsData
} from '../../../redux/actions/ns/investigationDetail';

import { getItemFromLocalStorage } from '../../../util/localStorageUtils';
import { isUiResourceAvailable } from '../../../util/index';

import style from './index.scss';
import { getSelectedResources } from '../../../util/resourceManager';

const INDIVIDUAL_VIEW = 0;
const CORPORATE_VIEW = 1;

const { nsUserManagementResources } = getSelectedResources();

export class InvestigationDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      workingHitStatus: 0,
      editorValue: Value.fromJSON(slateValueJson),
      pastHitModal: {
        isShown: false,
        data: []
      },
      hitsPagination: {
        offset: 0
      },
      pastHitsPagination: {
        offset: 0
      },
      selectedHitsPagination: {
        offset: 0
      },
      showSelectedHits: false,
      selectedHits: []
    };
  }

  componentDidMount() {
    const { authentication } = this.props;
    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    // make it default to true if user management is not used
    const defaultUserManagementFlag = isUsingUserManagement ? false : true;
    let isCustomerProfileAllowed = defaultUserManagementFlag;
    let isAlertDetailsAllowed = defaultUserManagementFlag;

    // start iterating widgets if authentication data is available
    // and if user management is allowed
    if (isUsingUserManagement) {
      // check if authentication data is there (UI resources)
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_CUSTOMER_PROFILE_WIDGET,
            listOfUiResources
          )
        ) {
          isCustomerProfileAllowed = true;
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_ALERT_DETAILS_WIDGET,
            listOfUiResources
          )
        ) {
          isAlertDetailsAllowed = true;
        }
      }
    }

    const permissions = {
      isCustomerProfileAllowed,
      isAlertDetailsAllowed
    };

    this.onRefreshAlertData(permissions);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    if (dispatch) {
      dispatch(resetInvestDetailData());
    }
  }

  // on hits page change
  onPageChanged = (newPage) => {
    const { investigationDetail } = this.props;
    if (investigationDetail?.alertDetail?.data?.alert) {
      const alertDetailData = investigationDetail.alertDetail.data.alert;
      this.setState(
        {
          ...this.state,
          hitsPagination: {
            offset: newPage
          }
        },
        () => {
          const { dispatch } = this.props;

          if (dispatch) {
            dispatch(
              getInvestDetailHitData({
                offset: newPage * 5,
                clusterVersion: alertDetailData.clusterVersion,
                alertType: alertDetailData.alertType,
                alertId: alertDetailData.alertId
              })
            );
          }
        }
      );
    }
  };

  onPastHitsPageChange = (newPage) => {
    const {
      pastHitModal: { isShown, data }
    } = this.state;
    const { dispatch, alertType } = this.props;
    const alertId = match.params.alertId;

    this.setState(
      {
        ...this.state,
        pastHitsPagination: {
          offset: newPage
        }
      },
      () => {
        if (dispatch) {
          if (alertType !== null && alertType !== undefined) {
            dispatch(
              getInvestDetailPastHitsData({
                alertId,
                ...data,
                alertType,
                offset: newPage * 5
              })
            );
          }
        }
      }
    );
  };

  onRefreshAlertData = (permissions) => {
    const {
      dispatch,
      match,
      location: { search },
      alertType
    } = this.props;

    if (match?.params?.alertId) {
      dispatch(
        getInvestDetailData({
          alertId: match.params.alertId,
          alertType,
          permissions
        })
      );
    }
  };

  // on selected hits page change
  onSelectedHitsPageChange = (newPage) => {
    const { selectedHits } = this.state;
    if (newPage + 1 > Math.ceil(selectedHits.length / 5)) {
      this.setState({
        ...this.state,
        selectedHitsPagination: {
          offset: newPage - 1
        }
      });
    } else {
      this.setState({
        ...this.state,
        selectedHitsPagination: {
          offset: newPage
        }
      });
    }
  };

  onToggleHitSelection = (updatedSelectedHits) => {
    const { selectedHits, offset } = this.state;
    if (
      Math.ceil(selectedHits.length / 5) >
      Math.ceil(updatedSelectedHits.length / 5)
    ) {
      this.setState({
        ...this.state,
        selectedHits: updatedSelectedHits,
        selectedHitsPagination: {
          offset: Math.ceil(updatedSelectedHits.length / 5) - 1
        }
      });
    } else {
      this.setState({
        ...this.state,
        selectedHits: updatedSelectedHits
      });
    }
  };

  onToggleSelectedHitsVisibility = (updateSelectedHitsVisibility) => {
    this.setState({
      ...this.state,
      showSelectedHits: updateSelectedHitsVisibility,
      selectedHitsPagination: {
        offset: 0
      }
    });
  };

  closePastHitModal = () => {
    const { dispatch } = this.props;
    this.setState(
      {
        ...this.state,
        pastHitModal: {
          isShown: false,
          data: []
        },
        pastHitsPagination: {
          offset: 0
        }
      },
      () => {
        if (dispatch) {
          dispatch(resetInvestDetailPastHitsData());
        }
      }
    );
  };

  togglePastHitModal = (data) => {
    const {
      pastHitModal: { isShown }
    } = this.state;
    const { dispatch, alertType, match } = this.props;
    const alertId = match.params.alertId;

    this.setState(
      {
        ...this.state,
        pastHitModal: {
          isShown: !isShown,
          data
        }
      },
      () => {
        if (dispatch) {
          if (alertType !== null && alertType !== undefined) {
            dispatch(
              getInvestDetailPastHitsData({
                ...data,
                alertId,
                alertType
              })
            );
          }
        }
      }
    );
  };

  renderCustomerProfilePanel = () => {
    const { investigationDetail } = this.props;
    const alertDetail = investigationDetail.alertDetail.data?.alert
      ? investigationDetail.alertDetail.data.alert
      : {};

    const buId = alertDetail.alertType;
    const customerProfileMetadata =
      buId === INDIVIDUAL_VIEW
        ? individualCustomerProfile
        : corperateCustomerProfile;

    return (
      <CustomerProfilePanel
        alertDetail={alertDetail}
        customerProfileMetadata={customerProfileMetadata}
      />
    );
  };

  renderHitsPager = () => {
    const { investigationDetail } = this.props;
    const {
      hitsPagination: { offset },
      showSelectedHits
    } = this.state;
    if (
      !showSelectedHits &&
      investigationDetail &&
      investigationDetail.alertDetail &&
      investigationDetail.alertDetail.data &&
      investigationDetail.alertDetail.data.hits
    ) {
      const alertDetailData = investigationDetail.alertDetail.data;
      const { totalCount } = alertDetailData;

      return (
        <Pager
          className={style.pager}
          titles={{ prev: '<', next: '>' }}
          total={Math.ceil(totalCount / 5) || 0}
          current={offset}
          visiblePages={5}
          onPageChanged={this.onPageChanged}
        />
      );
    }

    return;
  };

  renderSelectedHitsPager = () => {
    const {
      selectedHitsPagination: { offset },
      selectedHits,
      showSelectedHits
    } = this.state;
    if (
      showSelectedHits &&
      Array.isArray(selectedHits) &&
      selectedHits.length > 0
    ) {
      return (
        <Pager
          className={style.pager}
          titles={{ prev: '<', next: '>' }}
          total={Math.ceil(selectedHits.length / 5) || 0}
          current={offset}
          visiblePages={5}
          onPageChanged={this.onSelectedHitsPageChange}
        />
      );
    }

    return;
  };

  renderTopInfoBar = () => {
    const { investigationDetail } = this.props;
    const alertDetail = investigationDetail.alertDetail.data?.alert
      ? investigationDetail.alertDetail.data.alert
      : {};
    const buId = alertDetail.alertType;

    const topInfoBarData =
      buId === INDIVIDUAL_VIEW
        ? individualTopInfoBarData
        : corperateTopInfoBarData;

    return (
      <TopInfoBar alertDetail={alertDetail} topInfoBarData={topInfoBarData} />
    );
  };

  render() {
    const { investigationDetail, authentication } = this.props;
    const {
      pastHitModal,
      pastHitsPagination,
      selectedHits,
      showSelectedHits,
      selectedHitsPagination
    } = this.state;

    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    // make it default to true if user management is not used
    const defaultUserManagementFlag = isUsingUserManagement ? false : true;
    let isCustomerProfileAllowed = defaultUserManagementFlag;
    let isAlertDetailsAllowed = defaultUserManagementFlag;

    // start iterating widgets if authentication data is available
    // and if user management is allowed
    if (isUsingUserManagement) {
      // check if authentication data is there (UI resources)
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_CUSTOMER_PROFILE_WIDGET,
            listOfUiResources
          )
        ) {
          isCustomerProfileAllowed = true;
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_ALERT_DETAILS_WIDGET,
            listOfUiResources
          )
        ) {
          isAlertDetailsAllowed = true;
        }
      }
    }

    if (investigationDetail.alertDetail?.isLoading) {
      return (
        <div>
          <Alert color="info">
            <p>
              <i className="fa fa-info-circle"></i>
              &nbsp;&nbsp; Loading, please wait...
            </p>
          </Alert>
        </div>
      );
    }

    if (
      investigationDetail.alertDetail &&
      !investigationDetail.alertDetail.isLoading &&
      !investigationDetail.alertDetail.data
    ) {
      return (
        <div>
          <Alert color="info">
            <p>
              <i className="fa fa-info-circle"></i>
              &nbsp;&nbsp; No available data for this alert, click{' '}
              <a
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={this.onRefreshAlertData}>
                here
              </a>{' '}
              to try again.
            </p>
          </Alert>
        </div>
      );
    }

    const alertDetail = investigationDetail.alertDetail.data || {};
    const pastHitsData = investigationDetail.pastHitsData || {};
    const pastHitsList = pastHitsData?.data?.past ? pastHitsData.data.past : [];
    const pastHitsCount = pastHitsData?.data?.totalCount
      ? pastHitsData.data.totalCount
      : 0;
    const pastHitsPaginationOffset = pastHitsPagination.offset;

    //decide individual or corperate
    const buId = alertDetail.alert.alertType;
    const alertId = alertDetail.alert.alertId;

    return (
      <div className={style.wrapper}>
        <div className={style.content}>
          {/* <a className={style.backButton} href="/app/ns/investigation">
              <i class="fa fa-arrow-left"></i>
              &nbsp;
              Back
            </a> */}
          <div className={style.tableBody}>
            {this.renderTopInfoBar()}

            {isCustomerProfileAllowed && this.renderCustomerProfilePanel()}

            {isAlertDetailsAllowed && (
              <Explainability
                onTogglePastHitsModal={this.togglePastHitModal}
                onHitSelection={this.onToggleHitSelection}
                onShowSelectedHits={this.onToggleSelectedHitsVisibility}
                selectedHits={selectedHits}
                showSelectedHits={showSelectedHits}
                selectedHitsOffset={selectedHitsPagination.offset}
                buId={buId}
                data={alertDetail}>
                <div className="row">
                  <div className="col-md-7">
                    <div className={style.legendContainer}>
                      <ul>
                        <li className={style.legendItem}>
                          <div>
                            <div className={style.legendRed}></div> Mismatch
                          </div>
                        </li>

                        <li className={style.legendItem}>
                          <div>
                            <div className={style.legendOrange}></div>{' '}
                            Insufficient
                          </div>
                        </li>

                        <li className={style.legendItem}>
                          <div>
                            <div className={style.legendGreen}></div> Match
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-5">
                    {this.renderHitsPager()}
                    {this.renderSelectedHitsPager()}
                  </div>
                </div>
              </Explainability>
            )}

            <PastHitModal
              pastHitsCount={pastHitsCount}
              offset={pastHitsPaginationOffset}
              data={pastHitsList}
              isLoading={pastHitsData?.isLoading}
              onPastHitsPageChange={this.onPastHitsPageChange}
              pastHitModal={pastHitModal}
              closePastHitModal={this.closePastHitModal}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps = {}) {
  return {
    investigationDetail: state.nsInvestigationDetail,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch,
    navigateTo: (location) => {
      dispatch(push(location));
    },
    back: () => {
      dispatch(goBack());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvestigationDetail);
